import styled from "styled-components";
import { FC, useState } from "react";

import { Th } from "@/components/Table";
import Text from "@/components/Text";
import { SortableTh } from "@/components/Table";
import { SortState } from "@/types/resources";

const Tooltip = styled.div`
  position: absolute;
  top: 32px;
  right: -14px;
  width: 168px;
  z-index: 2;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 12px 26px rgba(34, 34, 34, 0.08);
  border-radius: 4px;
  border: 0.5px solid ${({ theme }) => theme.colors.lightGray};
  padding: 12px;
  padding-left: 16px;
`;

const Triangle = styled.div`
  width: 24px;
  height: 10px;
  position: absolute;
  overflow: hidden;
  top: -10px;
  right: 5px;
  &::after {
    border: 0.5px solid ${({ theme }) => theme.colors.lightGray};
    content: "";
    position: absolute;
    width: 10px;
    height: 10px;
    background: ${({ theme }) => theme.colors.white};
    transform: rotate(45deg);
    top: 6px;
    left: 5px;
  }
`;

const StyledTh = styled(Th)`
  span {
    &:first-child {
      cursor: help;
      position: relative;
    }
    svg {
      margin-left: 4px;
      transform: translateY(2px);
    }
  }
`;

const StyledSortableTh = styled(SortableTh)`
  span {
    position: relative;
    cursor: help;
    svg {
      margin-left: 4px;
      transform: translateY(2px);
    }
  }
`;

const ListItem = styled.li`
  position: relative;
  margin-bottom: 10px;
  position: relative;
  padding-left: 12px;
  &:before {
    content: "";
    left: 0;
    top: 5px;
    width: 4px;
    height: 4px;
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: 50%;
    position: absolute;
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

interface Props {
  sort?: SortState;
  setSort?: React.Dispatch<React.SetStateAction<SortState>>;
}

const OptimisationFinalValueTh: FC<Props> = ({ sort, setSort }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <>
      {!!sort && !!setSort ? (
        <StyledSortableTh
          title="Status"
          sort={sort}
          setSort={setSort}
          property="finalValue"
        >
          <span
            onMouseOver={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="6" cy="6" r="5.5" stroke="#E9E9E9" />
              <path
                d="M5.39844 4.25275V3.2998H6.59844V4.25275H5.39844ZM5.39844 8.6998V4.88804H6.59844V8.6998H5.39844Z"
                fill="#909090"
              />
            </svg>
            {showTooltip && (
              <Tooltip>
                <ul>
                  <ListItem>
                    <Text $type="smallBold">Final Youtube Value</Text>
                    <Text $type="extraSmall" $color="gray" as="span">
                      (CTR * 8m reach)
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text $type="smallBold">Final Facebook Value</Text>
                    <Text $type="extraSmall" $color="gray" as="span">
                      (3s * 1m reach)
                    </Text>
                  </ListItem>
                </ul>
                <Triangle />
              </Tooltip>
            )}
          </span>
        </StyledSortableTh>
      ) : (
        <StyledTh>
          <span
            onMouseOver={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            Status
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="6" cy="6" r="5.5" stroke="#E9E9E9" />
              <path
                d="M5.39844 4.25275V3.2998H6.59844V4.25275H5.39844ZM5.39844 8.6998V4.88804H6.59844V8.6998H5.39844Z"
                fill="#909090"
              />
            </svg>
            {showTooltip && (
              <Tooltip>
                <ul>
                  <ListItem>
                    <Text $type="smallBold">Final Youtube Value</Text>
                    <Text $type="extraSmall" $color="gray" as="span">
                      (CTR * 8m reach)
                    </Text>
                  </ListItem>
                  <ListItem>
                    <Text $type="smallBold">Final Facebook Value</Text>
                    <Text $type="extraSmall" $color="gray" as="span">
                      (3s * 1m reach)
                    </Text>
                  </ListItem>
                </ul>
                <Triangle />
              </Tooltip>
            )}
          </span>
        </StyledTh>
      )}
    </>
  );
};

export default OptimisationFinalValueTh;
